import { TrendingUp, TrendingDown, DollarSign, ShoppingBag, Users, Eye } from 'lucide-react';

const stats = [
  { name: 'Total Revenue', value: '$45,231', change: '+12.5%', trend: 'up', icon: DollarSign },
  { name: 'Total Orders', value: '1,234', change: '+8.2%', trend: 'up', icon: ShoppingBag },
  { name: 'Active Users', value: '3,456', change: '-2.4%', trend: 'down', icon: Users },
  { name: 'Page Views', value: '12.5K', change: '+15.3%', trend: 'up', icon: Eye },
];

export function Analytics() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">Analytics</h1>
      <p className="text-muted-foreground mb-8">Monitor your product performance and metrics.</p>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-8">
        {stats.map((stat) => {
          const Icon = stat.icon;
          const TrendIcon = stat.trend === 'up' ? TrendingUp : TrendingDown;
          const trendColor = stat.trend === 'up' ? 'text-green-500' : 'text-red-500';
          
          return (
            <div key={stat.name} className="glass-card p-6 rounded-xl">
              <div className="flex items-center justify-between mb-4">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                  <Icon className="h-5 w-5 text-primary" />
                </div>
                <span className={`flex items-center gap-1 text-sm ${trendColor}`}>
                  <TrendIcon className="h-4 w-4" />
                  {stat.change}
                </span>
              </div>
              <p className="text-2xl font-bold mb-1">{stat.value}</p>
              <p className="text-sm text-muted-foreground">{stat.name}</p>
            </div>
          );
        })}
      </div>

      <div className="glass-card p-6 rounded-xl">
        <h3 className="font-semibold mb-4">Revenue Overview</h3>
        <div className="h-64 flex items-center justify-center text-muted-foreground">
          <p>Chart placeholder - integrate with your preferred charting library</p>
        </div>
      </div>
    </div>
  );
}
